const IllumioSupportForm = { 
    isValidEmail: function(email) {
        if (/^\w+([\.-\\\'\\\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true;
        }
        console.error('Invalid email: ' + email);
        return false;
    },
    validate: function(obj, highlightError=false) {
        let status = false;
        if (!obj) 
            return status;
        
        if (obj instanceof NodeList || obj instanceof HTMLCollection) {
            if (obj.value) {
                status = true;
            } else {
                for (let i=0;i<obj.length;i++) {
                    if (obj[i].checked) {
                        status = true;
                        break;
                    }
                }
            }
        } else if (obj instanceof Element) {
            if (obj.nodeName==='INPUT' && (obj.type==='checkbox' || obj.type==='radio')) {
                status = obj.checked;
            } else if (obj.nodeName==='INPUT' && obj.type==='email') {
                status = IllumioSupportForm.isValidEmail(obj.value);
            } else { 
                status = (obj.value) ? true : false;
            }
        }
        
        if (highlightError) {
            let theElement = null;
            if ((obj instanceof NodeList || obj instanceof HTMLCollection) && obj.length>0) {
                theElement = obj[0];
            } else { 
                theElement = obj;
            }
            let labelId = `${theElement.form.id}-${theElement.name}`;
            labelId = labelId.replace(/(\[|\])*/g, '');
            let objLabel = document.getElementById(labelId);
            let errorElement = null;
            if (theElement.type!='checkbox' && theElement.type!='radio' && theElement.nextElementSibling) {
                errorElement = theElement.nextElementSibling; // Backward compatibility
                while (errorElement.nextElementSibling) {
                    errorElement = errorElement.nextElementSibling;
                }
            }
            if (!objLabel) {
                objLabel = obj.parentElement.previousElementSibling;
            }
console.log(objLabel);
            if (status) {
                if (objLabel) { 
                    objLabel.classList.remove('missing');
                    objLabel.classList.remove('error');
                }
                if (errorElement) { 
                    errorElement.classList.add('hide'); 
                    errorElement.classList.remove('error');
                }
            } else {
                if (objLabel) { 
                    objLabel.classList.add('missing');
                    objLabel.classList.add('error');
                }
                if (errorElement) { 
                    errorElement.classList.remove('hide'); 
                    errorElement.classList.add('error');
                    if (obj.nodeName==='INPUT' || obj.nodeName==='TEXTAREA') {
                        errorElement.style.width = obj.offsetWidth + 'px';
                    } else { 
                        errorElement.style.width = '50%';
                    }
                }
            }
        }
        
        return status;
    },
    validateForm: function(theForm, modalId) {
        let status = true;
        
        if (theForm && theForm.tagName==='DIV') {
            // This is used exclusively on my_illumio
            const fieldTypes = [ 'input', 'select', 'textarea' ];
            for (let i=0;i<fieldTypes.length;i++) {
                // var fields = document.forms['theForm'].getElementsByTagName(fieldTypes[i]);
                const fields = theForm.getElementsByTagName(fieldTypes[i]);
                for (let j=0;j<fields.length;j++) {
                    if (fields[j].required || fields[j].getAttribute('data-required') == 'true') {
                        if (!this.validate(fields[j], true)) {
                            status = false;    
                        }
                    }
                }
            }
        } else if (theForm && theForm.elements.length>0) {
            for (let i=0;i<theForm.elements.length;i++) {
                if (theForm.elements[i].required && !this.validate(theForm.elements[i])) {
                    status = false;    
                }
            }
        }
        
        if (status && modalId) {
            // --- If modalId exists, we assume POSTing the form via RESTful APIs. 
            // --- Need additional information to call the the APIs.
            
            // --- For demo purpose, let's assume this is done successfully. 
            // $(modalId).foundation('reveal', 'open');
            
            return false; // --- To prevent the page from being refreshed ---
        }
        
        return status;
    }, 
    enableDebugMode: function() {
        $('input[required]').removeAttr('required');
        $('select[required]').removeAttr('required');
        $('textarea[required]').removeAttr('required');
        $('form').prop('novalidate', 'novalidate');
    }, 
    /**
     * 
     * There is an optional argument isReturnObject, default as true. 
     * » true: { authenticity_token: '<csrf_token>' }
     * » false: '<csrf_token>'
     */
    getCsrf: function(isReturnObject=true) {
        const metadata = document.getElementsByTagName('meta');
        let csrfParam, csrfToken = null;
        for (const _data of metadata) {
            if (_data.name==='csrf-param') {
                csrfParam = _data.content;
            } else if (_data.name==='csrf-token') {
                csrfToken = _data.content;
            }
        }
        
        if (isReturnObject===false) {
            return csrfToken;
        }
       
        const csrf = {};
        csrf[csrfParam] = csrfToken;

        return csrf;
    }
};

export default IllumioSupportForm;